<template>
  <div></div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'TransactionsGetter',
  components: {},
  props: {
    searchText: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      latestSearchDate: 0,
    }
  },
  beforeUnmount() {},
  mounted() {
    this.search()
  },
  methods: {
    async search(searchText = this.searchText, page = this.page) {
      this.$emit('loading')
      const latestSearchDate = Date.now()
      this.latestSearchDate = latestSearchDate
      let res
      res = await this.$Events.sendDataRequestResolve('searchTransaction', {
        searchText,
        page,
      })
      if (this.latestSearchDate !== latestSearchDate) return
      this.$emit('result', res)
    },
    debunceSearch: debounce(function (text, filters) {
      this.search(text, filters)
    }, 300),
  },
  watch: {
    searchText(newText) {
      this.$emit('loading')
      this.debunceSearch(newText)
    },
    page(newPage) {
      this.$emit('loading')
      this.debunceSearch(this.searchText, newPage)
    },
  },
}
</script>
